<template>
  <div style="padding-top:30px">
    <div class="win" :style="'background-image:url('+oss+data.style.backgroundImage+')'">
      <!-- 背景比例 664  750   337 667-->
      <div class="main" :style="'color:'+data.style.title_color">
        <div class="title" >您没有获得奖励 再接再厉</div>
      </div>
      <div class="buttom" >
        <div class="button" >确认</div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "notWinning",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    console.log(123213);
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.win {
  width: 300px;
  height: 460px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  position: relative;
  .main {
    text-align: center;
    position: relative;
    border-radius: 10px;
    font-size: 12px;
    padding-top: 50px;
    .title {
      font-size: 22px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      width: 150px;
      text-align: center;
      margin: 0 auto;
      font-size: 25px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 600;
      padding-top: 32px;
      margin-bottom: 22px;
    }
    .scanDetail {
      text-align: center;
      color: #fff;
      font-size: 15px;
      width: 80px;
      height: 28px;
      border-radius: 35px;
      background: #ef8537;
      line-height: 28px;
      margin: 0 auto;
    }
  }
  .buttom {
    width: 247.5px;
    height: 171px;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    padding-top: 80px;
    box-sizing: border-box;
    .button {
      width: 166.25px;
      height: 50px;
      background-color: #ff5555;
      color: #fff;
      border-radius: 50px;
      background-size: contain;
      background-repeat: no-repeat;
      font-size: 16px;
      background-position: center;
      margin: 0 auto;
      line-height: 45px;
      text-align: center;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
    }
  }
}
</style>